import * as React from 'react'
// constants
import { Modals } from 'constants/index'
// hooks
import { useShowModal } from 'hooks/index'
// themes
import { Label, Wrapper, Button, Option, SetContainer } from './views'
import {
  EditIcon,
  TrashIcon,
  ButtonsWrapper
} from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
// types
import { IResponseTypesSet } from 'types/graphql'

interface Props {
  idx: number
  data: IResponseTypesSet
  removeOption: () => void
}

const ResponseTypesSetsList: React.FC<Props> = ({ idx, data, removeOption }) => {
  const { showModal } = useShowModal({ modalType: Modals.RESPONSE_TYPES_SET_MODAL })

  const editOption = () => showModal({ data })

  return (
    <Wrapper>
      <Label>SET {idx + 1}</Label>
      <SetContainer>
        {data.options.map((item) => (
          <React.Fragment key={item.id}>
            <Option color={item.color}>{item.label}</Option>
          </React.Fragment>
        ))}
      </SetContainer>

      <ButtonsWrapper>
        <Button onClick={editOption}>
          <EditIcon />
        </Button>
        <Button onClick={removeOption}>
          <TrashIcon />
        </Button>
      </ButtonsWrapper>
    </Wrapper>
  )
}

export default ResponseTypesSetsList
